












































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";
import SelectPopover from "@/components/SelectPopover.vue";

@Component({
  components: {
    BPopover,
    SelectPopover,
  },
  computed: mapGetters("schedule", ["checkedRows"]),
})
export default class UpdateStatusPopover extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  id = "update-status-popover";
  checkedRows!: any[];
  //appts: any[] =[];
  loading = false;
  statusSelected = null;
  get target() {
    return this.id + "-target";
  }
  get status() {
    return this.$store.state.schedule.status;
  }
  update() {
    this.$modal.show("dialog", {
      title: "Update Status",
      text:
        "Do you want to update " +
        this.checkedRows.length +
        " appointments, Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  await this.$store.dispatch("schedule/saveStatus", {
                    id: id,
                    statusId: this.statusSelected?.["id"],
                  });
                  
                  appt.updated = true;
                  appt.statusName = this.statusSelected?.["name"];
                  appt.statusBackColor = this.statusSelected?.["backColor"] || "white";
                  appt.statusFontColor = this.statusSelected?.["fontColor"] || "black";
                } catch (error) {
                  appt.updateError = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }

  setStatus(status: any) {
    this.statusSelected = status;
  }
  close() {
    if (this.loading) return;
    this.checkedRows.filter(r => r.updated = false);
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    this.$root.$emit("bv::hide::popover", this.id);
    console.log("UPDATE_STATUS_CLOSE");
  }
  hide(e: BvEvent) {
    if (this.loading) e.preventDefault();
   // this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("UPDATE_STATUS_HIDDEN");
  }
  get formatPhone() {
    return formatPhone;
  }
  mounted() {
    this.checkedRows.filter(r => r.updated = false);
  }
}
